import { render, staticRenderFns } from "./SubstituteScreen.vue?vue&type=template&id=4aa45197&scoped=true"
import script from "./SubstituteScreen.vue?vue&type=script&lang=js"
export * from "./SubstituteScreen.vue?vue&type=script&lang=js"
import style0 from "./SubstituteScreen.vue?vue&type=style&index=0&id=4aa45197&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa45197",
  null
  
)

export default component.exports